export default __webpack_public_path__ + "static/media/INCDtoken.ea999420.png";